import type { MatchGridColumnConfigItem } from '../../types/match-grid.types';
import { MatchGridColumn } from '../../enums/match-grid-column';

/**
 * Every configurable column, in the order and the state a reader starts with.
 *
 * **The order is the default configuration**, so a column added here arrives where it is put -
 * and, for a reader who has already saved, joins the end of whichever list this marks it for.
 */
export const DEFAULT_MATCH_GRID_COLUMNS: MatchGridColumnConfigItem[] = [
  { [MatchGridColumn.RANK]: true, label: 'Rank' },
  { [MatchGridColumn.TALENT_NAME]: true, label: 'Name' },
  { [MatchGridColumn.AVAILABILITY]: true, label: 'Availability' },
  { [MatchGridColumn.FEEDBACK_SCORE]: true, label: 'Avg. Feedback Score' },
  { [MatchGridColumn.FEEDBACK_RESPONSES]: true, label: 'Feedback Responses' },
  { [MatchGridColumn.EXPLANATION]: true, label: 'Fit Explanation' },
  { [MatchGridColumn.PROACTIVE]: true, label: 'Open to Proactive Submission' },
  { [MatchGridColumn.PRICING_RANGE]: true, label: 'Pricing Range' },
  { [MatchGridColumn.PROFILE_STATUS]: true, label: 'Profile Status' },
  { [MatchGridColumn.COMPENSATION]: true, label: 'Total Annual Compensation' },
  { [MatchGridColumn.YEARS_AT_AXIOM]: true, label: 'Years at Axiom' },
  { [MatchGridColumn.YOE]: true, label: 'YOE' },
  { [MatchGridColumn.TALENT_PHONE_NUMBER]: true, label: 'Phone Number' },
  { [MatchGridColumn.TALENT_EMAIL]: true, label: 'Email Address' },
  { [MatchGridColumn.BARRED_LOCATION]: true, label: 'Barred Location' },
  { [MatchGridColumn.TALENT_LOCATION]: true, label: 'Location' },
  {
    [MatchGridColumn.MIN_WEEKLY_HOURS_PER_POSITION]: true,
    label: 'Min Weekly Hours',
  },
  { [MatchGridColumn.OWNER_USER]: true, label: 'Talent Success Partner' },
  { [MatchGridColumn.TALENT_FLAG]: true, label: 'Talent Flag' },
];
